import { createSlice } from "@reduxjs/toolkit";
import { deepMerge } from "../utils/helper";
import Asset1 from "../assets/images/asset1.png";
import Asset2 from "../assets/images/asset2.png";
import Asset3 from "../assets/images/asset3.png";
import Asset4 from "../assets/images/asset3.png";
import Asset6 from "../assets/images/asset5.png";

export const assets = createSlice({
  name: "assets",
  initialState: {
    asset1: { src: Asset1 },
    asset2: { src: Asset2 },
    asset3: { src: Asset3 },
    asset4: { src: Asset4 },
    asset5: { src: Asset6 },
  },
  reducers: {
    setAssets: (state, action) => {
      const data = window.dynamicReview?.assets
        ? window.dynamicReview.assets
        : { ...action.payload };
      return {
        ...state,
        ...data,
      };
    },
    overrideAssets: (state, action) => {
      return deepMerge(state, action.payload);
    },
  },
});

export const { setAssets, overrideAssets } = assets.actions;
export default assets.reducer;
